import { render, staticRenderFns } from "./dictDetail.vue?vue&type=template&id=5bb66a5a&scoped=true"
import script from "./dictDetail.vue?vue&type=script&lang=js"
export * from "./dictDetail.vue?vue&type=script&lang=js"
import style0 from "./dictDetail.vue?vue&type=style&index=0&id=5bb66a5a&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb66a5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/test-cdp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bb66a5a')) {
      api.createRecord('5bb66a5a', component.options)
    } else {
      api.reload('5bb66a5a', component.options)
    }
    module.hot.accept("./dictDetail.vue?vue&type=template&id=5bb66a5a&scoped=true", function () {
      api.rerender('5bb66a5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/dict/dictDetail.vue"
export default component.exports